import { Api } from "../config/request";

export default {
  getJobs(queryParams) {
    return Api.get(`/driver-accounting/job-status${queryParams}`);
  },
  triggerJob(payload) {
    return Api.post("/driver-accounting/job-trigger", payload);
  },
};
